import Image from 'next/image';
import IconDarkCharcoal from './point_dark_charcoal.svg?url';
import IconThemePrimary from './point_theme_primary.svg?url';
import type { SvgImageProps } from '../types';

export const PointDarkCharcoalImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconDarkCharcoal} alt={alt} {...props} />;

export const PointThemePrimaryImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconThemePrimary} alt={alt} {...props} />;
